import http from '../plugins/axios'

export const getAllStatusesList = async (params) => {
  try {
    const response = await http.get(`/api/v2/statuses`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const storeStatuses = async (payload) => {
  try {
    const response = await http.post(`api/v2/setstatus/order`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}



